// extracted by mini-css-extract-plugin
export var container = "_7z-0";
export var icon = "_7z-1";
export var text = "_7z-2";